var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{ref:"modal",attrs:{"title":_vm.store.title,"ok-title":_vm.store.okTitle,"size":_vm.store.size,"hide-cancel-btn":""},on:{"ok":_vm.onOk}},[_c('p',[_vm._v(_vm._s(_vm.store.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }